import { render, staticRenderFns } from "./HealthEducationList.vue?vue&type=template&id=454a62a0&scoped=true"
import script from "./HealthEducationList.vue?vue&type=script&lang=js"
export * from "./HealthEducationList.vue?vue&type=script&lang=js"
import style0 from "./HealthEducationList.vue?vue&type=style&index=0&id=454a62a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454a62a0",
  null
  
)

export default component.exports